import type { Application } from '../@types/app';
import type { CookieKey } from '../modules/cookie';
import { Cookie } from '../modules/cookie';

import { isServer } from './isServer';

export const getCookieFromServerOrClient = (
  ctx: Application.IKoaContext | Application.ReduxNextPageContext,
  cookieName: CookieKey,
) => (isServer ? ctx.req.cookies.get(cookieName) : Cookie.get(cookieName));
